import { jsx as m } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import s from "@mui/material/FormLabel";
import d from "styled-components";
import "../LabelTooltip/LabelTooltip.js";
import b from "../LabelTooltip/utils.js";
const p = {
  root: "formLabelRoot",
  focused: "formLabelFocused",
  disabled: "formLabelDisabled",
  error: "formLabelError",
  filled: "formLabelFilled",
  required: "formLabelRequired",
  asterisk: "formLabelAsterisk"
}, L = d(s).withConfig({
  displayName: "StyledMaterialUIFormLabel"
})([
  "&&.formLabelRoot{width:",
  ";display:inline-block;font-weight:",
  ";color:",
  ";line-height:1.2em;margin:",
  ";text-align:left;white-space:pre-wrap;}&&.formLabelRoot .formLabelAsterisk{color:",
  ";}&&.formLabelRoot.formLabelError{color:",
  ";}&&.formLabelRoot.formLabelDisabled{color:",
  ";}"
], ({ $fullWidth: o }) => o ? "100%" : "auto", ({ theme: o }) => o.typography.fontWeightBold, ({ theme: o }) => o.text.primary, ({ $noMargin: o }) => o ? "0px" : "0px 0px 8px 0px", ({ theme: o }) => o.caution, ({ theme: o }) => o.caution, ({ theme: o }) => o.secondaryDisabled), c = /* @__PURE__ */ f(({ classes: o, children: e = void 0, tooltip: r = void 0, noMargin: l = !1, fullWidth: a = !1, ...i }, t) => /* @__PURE__ */ m(L, {
  ...i,
  ref: t,
  classes: {
    ...p,
    ...o
  },
  $noMargin: l,
  $fullWidth: a,
  children: b(e, r)
}));
c.displayName = "FormLabel";
export {
  c as default
};
